import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {useLocation, useNavigate} from "react-router-dom";
import {formatDate} from "../util/helpers";

export default function InsightDetail() {
    const [insight, setInsight] = useState();

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const insightId = queryParams.get("id");

    const requestData = () => {
        return axios.get(`/admin/v1/insight/${insightId}`).then((res) => {
            setInsight(res.data);
        });
    };

  const updateVisible = (next) => {
        const params = new URLSearchParams();
        params.append('visible', String(next));
        return axios
            .patch(`/admin/v1/insight/${insightId}/visible`, params, {
                headers: {'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'}
            })
            .then(() => requestData());
    };

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [insightId]);

    return (
            <div className="App">
                <div className="wrapper">
                    <div className="content-wrapper" style={{marginLeft: "0px"}}>
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-12">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item active">콘텐츠관리 &gt; 인사이트 &gt; 상세</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title" style={{fontWeight: "bold"}}>
                                                    인사이트 정보
                                                </h3>
                                            </div>
                                            <div className="card-body table-responsive p-0">
                                                <table className="table table-hover text-nowrap">
                                                    {insight && (
                                                            <tbody>
                                                            <tr>
                                                                <th style={{width: "120px"}}>ID</th>
                                                                <td>{insight.id}</td>
                                                                <th style={{width: "120px"}}>거래유형</th>
                                                                <td>{insight.tradeType === "SELL" ? "판매" : "구매"}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>가격</th>
                                                                <td>{insight.price?.toLocaleString?.() || insight.price}</td>
                                                                <th>상담(분)</th>
                                                                <td>{insight.consultMinutes}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>매칭수</th>
                                                                <td>{insight.chatRoomCount}</td>
                                                                <th>생성일</th>
                                                                <td>{formatDate(insight.createdAt)}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>작성자ID</th>
                                                                <td>
                                                                    <a
                                                                            href={`/page/users/detail?userId=${insight.memberId}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                    >
                                                                        {insight.memberId}
                                                                    </a>
                                                                </td>
                                                                <th>작성자닉네임</th>
                                                                <td>{insight.memberNickname}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>노출</th>
                                                                <td colSpan={3}>
                                                                    <span style={{marginRight: '10px'}}>{insight.visible ? 'ON' : 'OFF'}</span>
                                                                    <button type="button" className={`btn btn-${insight.visible ? 'warning' : 'success'}`} onClick={() => updateVisible(!insight.visible)}>
                                                                        {insight.visible ? 'OFF로 전환' : 'ON으로 전환'}
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>제목</th>
                                                                <td colSpan={3}>{insight.title}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>내용</th>
                                                                <td colSpan={3}
                                                                    style={{whiteSpace: "pre-wrap", textAlign: "left"}}>
                                                                    {insight.content}
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                    )}
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row" style={{marginTop: "30px", marginBottom: "10px"}}>
                                    <div style={{margin: "0 auto"}}>
                                        <button
                                                type="button"
                                                className="btn btn-outline-dark"
                                                onClick={() => navigate(-1)}
                                        >
                                            목록
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
    );
}
